import { useEffect, useRef, useState } from "react";

export default function ChatDemo () {
    const ws = useRef(null);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [isConnected, setIsConnected] = useState(false);

    useEffect(() => {
        ws.current = new WebSocket("wss://ws.postman-echo.com/raw");

        ws.current.onopen = () => {
            setIsConnected(true);
        };

        ws.current.onmessage = (event) => {
            setMessages((prev) => [
                ...prev,
                { text: event.data, isUser: false, time: new Date().toLocaleTimeString() }
            ]);
        };

        ws.current.onerror = (err) => ws.current.onclose = () => {
            setIsConnected(false);
        };

        return () => ws.current.close();
    }, []);

    const sendMessage = () => {
        if (!isConnected) {
            return;
        }

        if (!input.trim()) return;

        ws.current.send(input);

        setMessages((prev) => [
            ...prev,
            { text: input, isUser: true, time: new Date().toLocaleTimeString() }
        ]);

        setInput("");
    };

    return (
        <div style={{ padding: 20 }}>
            <h3>WebSocket Demo Chat</h3>
            <p>Status: {isConnected ? "🟢 Connected" : "🔴 Connecting..."}</p>

            <div
                style={{
                    height: 300,
                    border: "1px solid #ddd",
                    padding: 10,
                    overflowY: "auto",
                    marginBottom: 10
                }}
            >
                {messages.map((m, i) => (
                    <p
                        key={i}
                        style={{
                            textAlign: m.isUser ? "right" : "left",
                            background: m.isUser ? "#7C4DFF" : "#eee",
                            color: m.isUser ? "white" : "black",
                            padding: "8px 12px",
                            borderRadius: 10,
                            maxWidth: "70%",
                            marginLeft: m.isUser ? "auto" : 0,
                            marginRight: m.isUser ? 0 : "auto",
                        }}
                    >
                        {m.text}
                    </p>
                ))}
            </div>

            <input
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Type message…"
                style={{ padding: 10, width: "70%" }}
            />
            <button onClick={sendMessage} style={{ padding: 10, marginLeft: 10 }}>
                Send
            </button>
        </div>
    );
}
